import * as React from 'react'

type ScoreContext = {
  score?: string
  setScore: (value: string | undefined) => void
}

export const ScoreContext = React.createContext<ScoreContext>({ setScore: () => null })

export const ScoreProvider = ({ children }: React.PropsWithChildren) => {
  const [score, setScore] = React.useState<string>()

  return <ScoreContext.Provider value={{ score, setScore }}>{children}</ScoreContext.Provider>
}
